import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col, Collapse } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { FieldSpy } from "../../../../components/formik";

import { ButtonWithSpinner } from "../../../../components/common";

import LegalEntityFormFields from "./legal-entity-form-fields";
import NaturalPersonFormFields from "./natural-person-form-fields";

import {
  naturalPersonSearchValidationSchema,
  legalEntitySearchValidationSchema,
} from "../../validation-schemas";
import { optionsType } from "../../../../prop-types";
import {
  ENTITY_TYPE_OPTIONS,
  ENTRY_TYPE,
  FILTER_LABELS_WATCH_LIST_ENTRIES,
} from "../../constants/watchListEntryConstants";

import {
  watchListEntriesFiltersSelector,
  watchListEntriesLoadingSelector,
} from "../../selectors";
import { CollapseButton, CollapseOpenIcon } from "../../../../assets";
import Clickable from "../../../../components/common/Clickable";
import "./searchWatchListEntriesForm.css";
import {
  setWatchListEntriesSearchFilters,
  getWatchListEntries,
} from "../../actions";
import FormikButtonSelectManualSearch from "../../../../components/formik/manual-search/ButtonSelectManualSearch";
import { FaTimes } from "react-icons/fa";
import moment from "moment";
import { trimFormData } from "../../../../utilities/filters";

const percentageOptions = [
  { value: 50, label: "50" },
  { value: 75, label: "75" },
  { value: 80, label: "80" },
  { value: 85, label: "85" },
  { value: 90, label: "90" },
  { value: 95, label: "95" },
  { value: 100, label: "100" },
];

const SearchWatchListEntriesForm = ({
  nationalities,
  isOpenCollapse,
  toggleCollapse,
  watchListEntries,
}) => {
  const FILTERS_TEMPLATE = {
    firstName: "",
    middleName: "",
    lastName: "",
    fullName: "",
    birthDate: null,
    nationalityId: null,
    type: ENTRY_TYPE.NATURAL_PERSON,
    minimumMatchingPercentage: null,
  };

  const setFiltersOnTypeChange = (type) => ({
    ...FILTERS_TEMPLATE,
    type,
  });

  const dispatch = useDispatch();
  const filters = useSelector(watchListEntriesFiltersSelector);

  const [initialValues, setInitialValues] = useState(FILTERS_TEMPLATE);
  const formikRef = useRef(null);

  const [validationSchema, setValidationSchema] = useState(
    naturalPersonSearchValidationSchema
  );

  const [fields, setFields] = useState(
    <NaturalPersonFormFields
      percentageOptions={percentageOptions}
      nationalities={nationalities}
    />
  );

  const [typeSelected, setTypeSelected] = useState(ENTRY_TYPE.NATURAL_PERSON);

  const isLoading = useSelector(watchListEntriesLoadingSelector);

  const handleSubmit = (data) => {
    const formattedData = {
      ...data,
      birthDate: data.birthDate
        ? moment(data.birthDate).format("YYYY-MM-DDTHH:mm:ss")
        : data.birthDate,
    };
    const trimmedData = trimFormData(formattedData);
    dispatch(setWatchListEntriesSearchFilters(trimmedData));
    dispatch(getWatchListEntries());
    toggleCollapse();
  };

  function clearFilters() {
    dispatch(
      setWatchListEntriesSearchFilters({
        firstName: "",
        lastName: "",
        middleName: "",
        fullName: "",
        nationalityId: null,
        type: ENTRY_TYPE.NATURAL_PERSON,
        minimumMatchingPercentage: null,
      })
    );

    formikRef.current.setValues({
      firstName: "",
      lastName: "",
      middleName: "",
      fullName: "",
      nationalityId: null,
      type: ENTRY_TYPE.NATURAL_PERSON,
      minimumMatchingPercentage: null,
    });

    formikRef.current.resetForm();

    toggleCollapse();
  }

  useEffect(() => {
    setFields(
      typeSelected === ENTRY_TYPE.LEGAL_ENTITY ? (
        <LegalEntityFormFields
          percentageOptions={percentageOptions}
          nationalities={nationalities}
        />
      ) : (
        <NaturalPersonFormFields
          percentageOptions={percentageOptions}
          nationalities={nationalities}
        />
      )
    );
  }, [nationalities]);

  const handleIsLegalEntityChange = (type) => {
    setValidationSchema(
      type === ENTRY_TYPE.NATURAL_PERSON
        ? naturalPersonSearchValidationSchema
        : legalEntitySearchValidationSchema
    );
    setInitialValues({
      fullName: "",
      firstName: "",
      middleName: "",
      lastName: "",
      nationalityId: null,
      type,
    });

    dispatch(setWatchListEntriesSearchFilters(setFiltersOnTypeChange(type)));

    setTypeSelected(type);
    setFields(
      type === ENTRY_TYPE.LEGAL_ENTITY ? (
        <LegalEntityFormFields
          percentageOptions={percentageOptions}
          nationalities={nationalities}
        />
      ) : (
        <NaturalPersonFormFields
          percentageOptions={percentageOptions}
          nationalities={nationalities}
        />
      )
    );
  };

  return (
    <div>
      <Formik
        ref={formikRef}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnBlur={false}
        validateOnChange={false}
        enableReinitialize
      >
        <div>
          <div className="watch-list-collapse-search">
            <Collapse isOpen={isOpenCollapse}>
              <Form className=" watch-list-search">
                <div className="watch-list-search-inner-container">
                  <Row>
                    <Col lg={3} className="manual-search-types-box">
                      <Field
                        type="text"
                        name="type"
                        placeholder="Entity Type"
                        className="dropdown-group"
                        onChange={"somethnig"}
                        component={FormikButtonSelectManualSearch}
                        options={ENTITY_TYPE_OPTIONS}
                        isClearable
                      />
                      <FieldSpy
                        name="type"
                        onChange={handleIsLegalEntityChange}
                      />
                    </Col>

                    {/* Render Fields */}
                    {fields}
                    {/* Render Fields */}
                  </Row>
                  <Row>
                    <Col lg={4}>
                      {/*<Field type="text" name="details" placeholder="Full details" component={Input} />*/}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12} className="d-flex justify-content-center pt-2">
                      <ButtonWithSpinner
                        text="Search"
                        outline
                        type="submit"
                        className=" search-button-watch-list"
                        loading={isLoading}
                      />
                    </Col>
                  </Row>
                </div>
              </Form>
              <div
                style={{ marginTop: -6 }}
                className="watch-list-filters-menu-collapse-button"
              >
                {watchListEntries.length ? (
                  <Clickable onClick={toggleCollapse}>
                    <CollapseButton />
                  </Clickable>
                ) : null}
              </div>
            </Collapse>
          </div>
          <div
            style={{ marginTop: -6 }}
            className="watch-list-filters-menu-collapse-button"
          >
            <Clickable onClick={toggleCollapse}>
              {!isOpenCollapse ? <CollapseOpenIcon /> : null}
            </Clickable>
          </div>
          <div className="watch-list-filters-main-container">
            <Row>
              <Col lg={10}>
                <div className="single-filters-container">
                  {Object.values(filters).some(Boolean) ? (
                    <div className="filters-menu-label">Filter Applied</div>
                  ) : null}

                  {Object.entries(filters).map(([key, value], i) => {
                    return value ? (
                      <SingleFilter
                        key={key}
                        filterKey={key}
                        filterValue={value}
                        clearFilter={() => clearSingleFilter(key)}
                      />
                    ) : null;
                  })}

                  {Object.values(filters).some(Boolean) ? (
                    <div
                      onClick={clearFilters}
                      className="filters-menu-label-clear"
                    >
                      Clear All
                    </div>
                  ) : null}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Formik>
    </div>
  );

  function clearSingleFilter(filterKey) {
    let val = null;
    const currentFilters = { ...filters };
    if (filterKey === "type") {
      return;
    }

    if (
      filterKey === "firstName" ||
      filterKey === "middleName" ||
      filterKey === "lastName"
    ) {
      val = "";
    }

    dispatch(
      setWatchListEntriesSearchFilters({
        [filterKey]: val,
      })
    );

    currentFilters[filterKey] = val;

    formikRef.current.setFieldValue(filterKey, initialValues[filterKey]);

    if (filters.type === ENTRY_TYPE.NATURAL_PERSON) {
      if (filters.firstName && filters.lastName) {
        dispatch(getWatchListEntries());
      }
    } else {
      if (filters.fullName) {
        dispatch(getWatchListEntries());
      }
    }
  }

  function SingleFilter({
    filterKey = "",
    filterValue = "",
    clearFilter = () => {},
  }) {
    let currentValue = filterValue;
    if (filterKey === "type" && filterValue) {
      // set type label
      currentValue = ENTITY_TYPE_OPTIONS.find(
        (type) => type.value === filterValue
      ).label;
    }

    if (filterKey === "birthDate" && filterValue) {
      // format date
      currentValue = moment(new Date(filterValue)).format("DD.MM.yyyy");
    }

    if (filterKey === "nationalityId" && filterValue) {
      if (nationalities.length) {
        const label = nationalities.find(
          (nat) => parseInt(nat.value, 10) === parseInt(filterValue, 10)
        ).label;

        currentValue = label;
      }
    }

    return (
      <div className="single-filter-box">
        <div className="single-filter-label">
          {FILTER_LABELS_WATCH_LIST_ENTRIES[filterKey]}
        </div>
        <div className="single-filter-chip">
          {currentValue}
          {filterKey !== "type" &&
          filterKey !== "firstName" &&
          filterKey !== "fullName" &&
          filterKey !== "lastName" ? (
            <FaTimes
              className="remove-filter-icon"
              onClick={clearFilter}
              color="#707070"
            />
          ) : null}
        </div>
      </div>
    );
  }
};

SearchWatchListEntriesForm.propTypes = {
  nationalities: optionsType.isRequired,
};

export default SearchWatchListEntriesForm;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-entries-form/SearchWatchListEntriesForm.jsx